// Navigation
export const CHANGE_PAGE = "CHANGE_PAGE";                 // type
export const HOME_PAGE = "HOME_PAGE"                      // value
export const PYTHON_PAGE = "PYTHON_PAGE"                  // value
export const JAVASCRIPT_PAGE = "JAVASCRIPT_PAGE"          //value
export const CSS_PAGE = "CSS_PAGE"                        //value
export const REACT_PAGE = "REACT_PAGE"                    //value
export const ARTICLE_PAGE = "ARTICLE_PAGE"                // value
export const FETCH_BLOGS_SUCCESS = "FETCH_BLOGS_SUCCESS"  // type